import { FC } from 'react';

import styled from '@emotion/styled';
import { useGetSignInTnCQuery } from 'store/terms-and-conditions/termsAPI';
import DOMPurify from 'dompurify';

import { Button } from '@britishcouncil/react-solas';
import { Modal } from '@britishcouncil/react-solas-ors3';

export const TnCModal: FC<{ show: boolean; onExit: () => void }> = ({ show, onExit }) => {
  let { data, isFetching } = useGetSignInTnCQuery();
  return (
    <Modal
      show={show}
      title="Signup Terms and Conditions"
      onExit={onExit}
      isLoading={isFetching}
      footer={
        <Footer>
          <Button intent="primary" onClick={onExit}>
            Ok
          </Button>
          <Button intent="default" onClick={onExit}>
            Cancel
          </Button>
        </Footer>
      }
    >
      <Container>
        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data?.text || '') }} />
      </Container>
    </Modal>
  );
};

const Footer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`;

const Container = styled.div`
  max-width: 632px;
`;
